import CreateItemResponse from "../types/CreateItemResponse";
import axiosInstance from "./axiosInstance";
import PlaceRequest from "../types/PlaceRequest";
import PlacesResponse from "../types/PlacesResponse";

export const postPlace = async (request: PlaceRequest): Promise<CreateItemResponse | void> => {
    return axiosInstance.post<CreateItemResponse>("/places", request)
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const fetchPlaces = async (params: { page?: number, limit?: number, name?: string } = {}): Promise<PlacesResponse | void> => {
    return axiosInstance.get<PlacesResponse>("/places", { params })
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const deletePlace = async (id: number): Promise<void> =>
    axiosInstance.delete<void>(`/places/${id}`)
        .then(response => response.data)
        .catch(error => error.response.data)